import { businessService } from '@/pages/Business/services/business.service';
import { PaginatedRequest } from '@/types';
import type {
  AuthorizationTransition,
  AuthorizationsFilter,
  AuthorizationsResponse,
} from '../models';

export type GetAuthorizationsArgs = {
  filters: AuthorizationsFilter;
  paginated: PaginatedRequest;
};

const authorizationsApi = businessService.injectEndpoints({
  endpoints: (builder) => ({
    getAuthorizations: builder.query<
      AuthorizationsResponse,
      GetAuthorizationsArgs
    >({
      query: ({ filters, paginated }) => ({
        url: '/authorization-transitions',
        params: {
          limit: paginated.pageSize,
          offset: (paginated.page - 1) * paginated.pageSize,
          ...(filters.status && { status: filters.status }),
          ...(filters.requestDriverId && { requestDriverId: filters.requestDriverId }),
          ...(filters.authorizationUserId && { authorizationUserId: filters.authorizationUserId }),
          ...(filters.transitionId && { transitionId: filters.transitionId }),
          ...(filters.requestedFrom && { requestedFrom: filters.requestedFrom }),
          ...(filters.requestedTo && { requestedTo: filters.requestedTo }),
        },
      }),
      providesTags: ['AuthorizationTransitions'],
    }),
    getAuthorizationById: builder.query<
      AuthorizationTransition,
      { id: string }
    >({
      query: ({ id }) => ({
        url: `/authorization-transitions/${id}`,
      }),
      providesTags: (_result, _error, arg) => [
        { type: 'AuthorizationTransitions', id: arg.id },
      ],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetAuthorizationsQuery,
  useGetAuthorizationByIdQuery,
} = authorizationsApi;

export default authorizationsApi;
